import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  
  heroTextTitleWrapper: {
    marginBottom: 30,
  },

  heroTextTitle: {
    marginBlock: 0,
    textAlign: 'left',
    width: 'auto'
  },
})

export default useStyles